import React from "react";

const style = {
    height: '1px',
    width: '100%',
    backgroundColor: '#e2e2e2'
}

export default function Seperator() {
    return (
        <div style={style}></div>
    );
}
